import { defineRecipe } from '@chakra-ui/react'

export const surfaceCardRecipe = defineRecipe({
  className: 'ui-surface-card',
  base: {
    bg: 'var(--theme-card-background)',
    border: '[1px solid var(--theme-accent-border)]',
    borderRadius: 'xl',
    color: '[inherit]',
    display: 'block',
    textDecoration: 'none',
    transition: '[transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease]',
    _focusVisible: {
      boxShadow: '[0 0 0 3px var(--coach-accent-30)]',
    },
  },
  variants: {
    variant: {
      default: {},
      interactive: {
        _hover: {
          transform: '[translateY(-2px)]',
          boxShadow: 'var(--shadow-lg)',
          borderColor: 'var(--coach-accent)',
        },
      },
      selected: {
        borderColor: 'var(--coach-accent)',
        transform: '[translateY(-2px)]',
        boxShadow: 'var(--shadow-lg)',
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})
